export default __webpack_public_path__ + "build/beded4ebd4b684a7bdd9cdd5a080ceb2.svg";